(function() {
  if (window.GbcSubscriptionShared) return;

  function parsePrice(value) {
    if (typeof value === 'number') return value;
    if (typeof value !== 'string') return 0;
    return parseFloat(value.replace(/,/g, '')) || 0;
  }

  function getPlanMonths(plan) {
    if (!plan || !plan.name) return Number.MAX_SAFE_INTEGER;
    var normalized = String(plan.name).toLowerCase().replace(/\s+/g, ' ').trim();
    var match = normalized.match(/(\d+)\s*month/);
    if (match && match[1]) return Number(match[1]);
    return Number.MAX_SAFE_INTEGER;
  }

  function bindOptionSelection(root) {
    if (!root) return;
    root.querySelectorAll('.subscription-step__option').forEach(function(opt) {
      opt.addEventListener('click', function(e) {
        if (e.target.tagName === 'BUTTON') return;
        var radio = opt.querySelector('input[type="radio"]');
        if (!radio) return;
        var name = radio.name;
        root.querySelectorAll('input[name="' + name + '"]').forEach(function(r) { r.checked = false; });
        radio.checked = true;
        root.querySelectorAll('input[name="' + name + '"]').forEach(function(r) {
          var option = r.closest('.subscription-step__option');
          if (option) option.classList.remove('subscription-step__option--selected');
        });
        opt.classList.add('subscription-step__option--selected');
      });
    });
  }

  function bindPlanButtons(root, options) {
    if (!root) return;
    var opts = options || {};
    root.querySelectorAll('.subscription-step__plans-btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var group = btn.closest('.subscription-step__options');
        if (!group) return;
        group.querySelectorAll('.subscription-step__plans-btn').forEach(function(b) { b.classList.remove('subscription-step__plans-btn--selected'); });
        btn.classList.add('subscription-step__plans-btn--selected');

        var planId = btn.dataset.planId;
        var subscribeOption = btn.closest('.subscription-step__option');
        if (!subscribeOption) return;

        var subscribeRadio = subscribeOption.querySelector('input[type="radio"]');
        if (subscribeRadio && planId) {
          subscribeRadio.value = planId;
          subscribeRadio.checked = true;
        }

        var name = subscribeRadio ? subscribeRadio.name : null;
        if (name) {
          root.querySelectorAll('input[name="' + name + '"]').forEach(function(r) {
            var option = r.closest('.subscription-step__option');
            if (option) option.classList.remove('subscription-step__option--selected');
          });
          subscribeOption.classList.add('subscription-step__option--selected');
        }

        if (typeof opts.onPlanChange === 'function') {
          opts.onPlanChange({
            button: btn,
            subscribeOption: subscribeOption
          });
        }
      });
    });
  }

  function collectChoices(root) {
    if (!root) return { main: null, upsells: [] };
    var choices = { main: null, upsells: [] };
    root.querySelectorAll('input[name="subscription_main"]').forEach(function(r) {
      if (r.checked && r.value) choices.main = parseInt(r.value, 10);
    });
    root.querySelectorAll('[data-subscription-upsell]').forEach(function(block) {
      var variantIdInput = block.querySelector('input[name="subscript_upsell_variant_id"]');
      var selectedPlanInput = block.querySelector('input[name^="subscript_upsell_plan_"]:checked');
      if (variantIdInput) {
        choices.upsells.push({
          variant_id: parseInt(variantIdInput.value, 10),
          selling_plan_id: selectedPlanInput && selectedPlanInput.value ? parseInt(selectedPlanInput.value, 10) : null
        });
      }
    });
    return choices;
  }

  function escapeHtml(value) {
    if (value === null || value === undefined) return '';
    return String(value).replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function planIntervalLabel(plan, index) {
    var fallback = (index + 1) + ' month' + (index > 0 ? 's' : '');
    var rawName = plan && plan.name ? String(plan.name) : '';
    if (!rawName) return fallback;
    var normalized = rawName.toLowerCase().replace(/\s+/g, ' ').trim();
    var match = normalized.match(/(\d+)\s*month/);
    if (match && match[1]) {
      var n = Number(match[1]);
      return n + ' month' + (n > 1 ? 's' : '');
    }
    return rawName;
  }

  function extractPlanDiscountPercent(basePrice, planPriceValue, plan) {
    var rawName = plan && plan.name ? String(plan.name).toLowerCase() : '';
    var nameMatch = rawName.match(/(\d+)\s*%/);
    if (nameMatch && nameMatch[1]) {
      return Number(nameMatch[1]) || 0;
    }
    var base = parsePrice(basePrice);
    var planPrice = parsePrice(planPriceValue);
    if (base && planPrice && planPrice < base) {
      return Math.round(((base - planPrice) / base) * 100) || 0;
    }

    return 0;
  }

  function planSavingsLabel(basePrice, planPriceValue, plan) {
    var pct = extractPlanDiscountPercent(basePrice, planPriceValue, plan);
    return pct > 0 ? ('save ' + pct + '%') : '';
  }

  function getMaxPlanDiscountPercent(basePrice, plans) {
    if (!Array.isArray(plans) || !plans.length) return 0;
    return plans.reduce(function(maxPct, plan) {
      var pct = extractPlanDiscountPercent(basePrice, plan && plan.price, plan);
      return Math.max(maxPct, pct);
    }, 0);
  }

  function sortPlansByMonths(plans) {
    if (!Array.isArray(plans)) return [];
    if (plans.length <= 1) return plans.slice();
    return plans.slice().sort(function(a, b) {
      return getPlanMonths(a) - getPlanMonths(b);
    });
  }

  function buildSubscriptionStepHtml(config) {
    var cfg = config || {};
    var formatMoney = (typeof cfg.formatMoney === 'function')
        ? cfg.formatMoney
        : function(v) { return '&pound;' + parsePrice(v).toFixed(2); };
    var wrapInContainer = cfg.wrapInContainer !== false;
    var withOptionHeader = !!cfg.withOptionHeader;
    var planButtonStyle = cfg.planButtonStyle === 'split' ? 'split' : 'single';
    var requireMainSellingPlanId = !!cfg.requireMainSellingPlanId;
    var forceUpsellsOneTime = !!cfg.forceUpsellsOneTime;

    var productTitle = cfg.productTitle || 'Main product';
    var heading = cfg.heading || 'Choose purchase option';
    var mainPrice = parsePrice(cfg.mainPrice || 0);
    var mainVariantSellingPlanId = cfg.mainVariantSellingPlanId || '';
    var mainVariantSellingPlans = sortPlansByMonths(cfg.mainVariantSellingPlans || []);
    var selectedUpsells = Array.isArray(cfg.upsells) ? cfg.upsells : [];
    var actionsHtml = cfg.actionsHtml || '';

    var html = wrapInContainer ? '<div class="subscription-step">' : '';
    html += '<h2 class="subscription-step__heading">' + escapeHtml(heading) + '</h2>';

    var mainHasSubscribe = requireMainSellingPlanId
        ? (!!mainVariantSellingPlanId && mainVariantSellingPlans.length > 0)
        : (!!mainVariantSellingPlanId || mainVariantSellingPlans.length > 0);
    var firstPlan = mainVariantSellingPlans[0];
    var mainMaxDiscount = getMaxPlanDiscountPercent(mainPrice, mainVariantSellingPlans);
    var mainFirstPlanDiscount = extractPlanDiscountPercent(mainPrice, firstPlan ? firstPlan.price : null, firstPlan);

    if (mainHasSubscribe) {
      html += '<div class="subscription-step__item">';
      html += '<h3 class="subscription-step__item-title">' + escapeHtml(productTitle) + '</h3>';
      html += '<div class="subscription-step__options">';

      html += '<label class="subscription-step__option subscription-step__option--selected" data-option="subscribe" data-max-discount="' + mainMaxDiscount + '">';
      html += '<input type="radio" name="subscription_main" value="' + (firstPlan ? firstPlan.id : mainVariantSellingPlanId) + '" checked>';
      if (withOptionHeader) html += '<div class="subscription-step__option-header">';
      html += '<span class="subscription-step__option-radio"></span>';
      html += '<span class="subscription-step__option-label">Subscribe &amp; save</span>';
      // html += '<span class="subscription-step__option-badge">Save up to ' + mainMaxDiscount + '%</span>';
      html += '<span class="subscription-step__option-badge">MOST POPULAR</span>';
      if (withOptionHeader) html += '</div>';
      html += '<div class="subscription-step__option-prices">';
      html += '<span class="subscription-step__original-price">' + formatMoney(mainPrice) + '</span>';
      html += '<span class="subscription-step__discounted-price">' + formatMoney(firstPlan ? firstPlan.price : mainPrice) + '</span>';
      html += '</div>';
      html += '<ul class="subscription-step__option-benefits"><li>Save ' + mainFirstPlanDiscount + '%</li><li>Free shipping</li><li>No commitment. Cancel anytime</li></ul>';

      if (mainVariantSellingPlans.length > 1) {
        html += '<p class="subscription-step__plans-label">Test every:</p>';
        html += '<div class="subscription-step__plans-buttons">';
        mainVariantSellingPlans.forEach(function(plan, i) {
          if (planButtonStyle === 'split') {
            var savings = planSavingsLabel(mainPrice, plan.price, plan);
            html += '<button type="button" class="subscription-step__plans-btn ' + (i === 0 ? 'subscription-step__plans-btn--selected' : '') + '" data-plan-id="' + plan.id + '" data-plan-price="' + (plan.price || '') + '" data-plan-discount="' + extractPlanDiscountPercent(mainPrice, plan.price, plan) + '">' +
                '<span class="subscription-step__plans-btn-interval">' + escapeHtml(planIntervalLabel(plan, i)) + '</span>' +
                '<span class="subscription-step__plans-btn-discount">' + (savings || '&nbsp;') + '</span>' +
                '</button>';
          } else {
            html += '<button type="button" class="subscription-step__plans-btn ' + (i === 0 ? 'subscription-step__plans-btn--selected' : '') + '" data-plan-id="' + plan.id + '" data-plan-price="' + (plan.price || '') + '">' + escapeHtml(plan && plan.name ? plan.name : planIntervalLabel(plan, i)) + '</button>';
          }
        });
        html += '</div>';
      }
      html += '</label>';

      html += '<label class="subscription-step__option" data-option="onetime">';
      html += '<input type="radio" name="subscription_main" value="">';
      if (withOptionHeader) html += '<div class="subscription-step__option-header">';
      html += '<span class="subscription-step__option-radio"></span>';
      html += '<span class="subscription-step__option-label">One-time Purchase</span>';
      if (withOptionHeader) html += '</div>';
      html += '<div class="subscription-step__one-time-price">' + formatMoney(mainPrice) + '</div>';
      html += '</label>';

      html += '</div></div>';
    }

    var visibleUpsells = selectedUpsells.filter(function(u) { return !!u; });

    if (forceUpsellsOneTime && visibleUpsells.length) {
      html += '<div class="subscription-step__item subscription-step__item--bolt-ons">';
      html += '<h3 class="subscription-step__item-title subscription-step__item-title--bolt-ons">Bolt-ons <span class="subscription-step__item-title-note">(not available for subscriptions).</span></h3>';
      html += '<div class="subscription-step__bolt-ons-list">';

      visibleUpsells.forEach(function(u, idx) {
        html += '<div class="subscription-step__bolt-on" data-subscription-upsell>';
        html += '<div class="subscription-step__bolt-on-selection" aria-hidden="true">';
        html += '<input type="hidden" name="subscript_upsell_variant_id" value="' + u.id + '">';
        html += '<input type="radio" name="subscript_upsell_plan_' + idx + '" value="" checked>';
        html += '</div>';
        html += '<p class="subscription-step__bolt-on-title">' + escapeHtml(u.title || '') + '</p>';
        html += '</div>';
      });

      html += '</div></div>';
    } else {
      visibleUpsells.forEach(function(u, idx) {
        if (!u) return;
        var upsellCanSubscribe = !!(u.selling_plan_id || (u.selling_plans && u.selling_plans.length > 0));
        if (!upsellCanSubscribe && !forceUpsellsOneTime) return;

        var upsellPrice = parsePrice(u.price);
        var upsellBasePrice = parsePrice(u.original_price || u.price);
        var upsellPlans = sortPlansByMonths(u.selling_plans || []);
        var upsellFirstPlan = upsellPlans[0];
        var planId = upsellFirstPlan ? upsellFirstPlan.id : u.selling_plan_id;
        var upsellMaxDiscount = getMaxPlanDiscountPercent(upsellBasePrice, upsellPlans);
        var upsellFirstPlanDiscount = extractPlanDiscountPercent(upsellBasePrice, upsellFirstPlan ? upsellFirstPlan.price : null, upsellFirstPlan);

        html += '<div class="subscription-step__item" data-subscription-upsell>';
        html += '<input type="hidden" name="subscript_upsell_variant_id" value="' + u.id + '">';
        html += '<h3 class="subscription-step__item-title">' + escapeHtml(u.title || '') + '</h3>';
        html += '<div class="subscription-step__options">';

        if (!forceUpsellsOneTime && upsellCanSubscribe) {
          html += '<label class="subscription-step__option subscription-step__option--selected" data-max-discount="' + upsellMaxDiscount + '">';
          html += '<input type="radio" name="subscript_upsell_plan_' + idx + '" value="' + planId + '" checked>';
          if (withOptionHeader) html += '<div class="subscription-step__option-header">';
          html += '<span class="subscription-step__option-radio"></span>';
          html += '<span class="subscription-step__option-label">Subscribe &amp; save</span>';
          // html += '<span class="subscription-step__option-badge">Save up to ' + upsellMaxDiscount + '%</span>';
          html += '<span class="subscription-step__option-badge">MOST POPULAR</span>';
          if (withOptionHeader) html += '</div>';
          html += '<div class="subscription-step__option-prices">';
          html += '<span class="subscription-step__original-price">' + formatMoney(upsellBasePrice) + '</span>';
          html += '<span class="subscription-step__discounted-price">' + formatMoney(upsellFirstPlan ? upsellFirstPlan.price : upsellBasePrice) + '</span>';
          html += '</div>';
          html += '<ul class="subscription-step__option-benefits"><li>Save ' + upsellFirstPlanDiscount + '%</li><li>Free shipping</li><li>No commitment. Cancel anytime</li></ul>';

          if (upsellPlans.length > 1) {
            html += '<p class="subscription-step__plans-label">Test every:</p>';
            html += '<div class="subscription-step__plans-buttons">';
            upsellPlans.forEach(function(plan, i) {
              if (planButtonStyle === 'split') {
                var savings = planSavingsLabel(upsellBasePrice, plan.price, plan);
                html += '<button type="button" class="subscription-step__plans-btn ' + (i === 0 ? 'subscription-step__plans-btn--selected' : '') + '" data-plan-id="' + plan.id + '" data-plan-price="' + (plan.price || '') + '" data-plan-discount="' + extractPlanDiscountPercent(upsellBasePrice, plan.price, plan) + '">' +
                    '<span class="subscription-step__plans-btn-interval">' + escapeHtml(planIntervalLabel(plan, i)) + '</span>' +
                    '<span class="subscription-step__plans-btn-discount">' + (savings || '&nbsp;') + '</span>' +
                    '</button>';
              } else {
                html += '<button type="button" class="subscription-step__plans-btn ' + (i === 0 ? 'subscription-step__plans-btn--selected' : '') + '" data-plan-id="' + plan.id + '" data-plan-price="' + (plan.price || '') + '">' + escapeHtml(plan && plan.name ? plan.name : planIntervalLabel(plan, i)) + '</button>';
              }
            });
            html += '</div>';
          }
          html += '</label>';
        }

        html += '<label class="subscription-step__option ' + (forceUpsellsOneTime ? 'subscription-step__option--selected' : '') + '">';
        html += '<input type="radio" name="subscript_upsell_plan_' + idx + '" value="" ' + (forceUpsellsOneTime ? 'checked' : '') + '>';
        if (withOptionHeader) html += '<div class="subscription-step__option-header">';
        html += '<span class="subscription-step__option-radio"></span>';
        html += '<span class="subscription-step__option-label">One-time Purchase</span>';
        if (withOptionHeader) html += '</div>';
        html += '<div class="subscription-step__one-time-price">' + formatMoney(upsellPrice) + '</div>';
        html += '</label>';
        html += '</div></div>';
      });
    }

    html += actionsHtml;
    if (wrapInContainer) html += '</div>';
    return html;
  }

  window.GbcSubscriptionShared = {
    parsePrice: parsePrice,
    getPlanMonths: getPlanMonths,
    bindOptionSelection: bindOptionSelection,
    bindPlanButtons: bindPlanButtons,
    collectChoices: collectChoices,
    buildSubscriptionStepHtml: buildSubscriptionStepHtml
  };
})();
